export default __webpack_public_path__ + "static/benches-8665f51c6c88b303a065abbffde92fe2.png";